import React, { useEffect, useRef } from "react";
// import Chart from "react-apexcharts";
import DiamondCharacteristics from "./diamondCharacteristics";
import DiamondRare from "./diamondrarity";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
// import { getColorCode } from "../../utils/graphColor";
import { formatDateReport } from "../../utils/dateUtils";

const ChartData = ({ color, value, label }) => {

  const getColorCode = (color) => {
    let GraphTextColor;
    switch (color) {
      case "Yellow":
        return "#ffda1a";
      case "Greenish Yellow":
        GraphTextColor = "#333";
        return "#c1e51a";
      case "Orange Yellow":
        return "#ffa330";
      case "Pink":
        return "#f563c0";
      case "Orangy Pink":
        return "#dc7979";
      case "Purplish Pink":
        GraphTextColor = "#333";
        return "#cf2985";
      case "Pinkish Purple":
        return "#a07aa0";
      case "Brownish Pink":
        GraphTextColor = "#333";
        return "#de7394";
      case "Brown Pink":
        GraphTextColor = "#333";
        return "#bc5b78";
      case "Blue":
        return "#4380c5";
      case "Gray Blue":
        return "#97bbe0";
      case "Green Blue":
        GraphTextColor = "#333";
        return "#55887e";
      case "Grayish Blue":
        GraphTextColor = "#333";
        return "#8faac5";
      case "Orange":
        GraphTextColor = "#333";
        return "#ff7c31";
      case "Yellow Orange":
        GraphTextColor = "#333";
        return "#fa9922";
      case "Yellowish Orange":
        GraphTextColor = "#333";
        return "#ff8630";
      case "Brown Orange":
        return "#d67f4a";
      case "Green":
        return "#547055";
      case "Yellow Green":
        GraphTextColor = "#333";
        return "#57ee1a";
      case "Blueish Green":
        GraphTextColor = "#333";
        return "#326b72";
      case "Red":
        GraphTextColor = "#333";
        return "#ec394d";
      case "Purplish Red":
        return "#ec3968";
      case "Brownish Red":
        return "#A52A2A";
      case "Gray":
        GraphTextColor = "#333";
        return "#8f8f8f";
      case "Blue Gray":
        GraphTextColor = "#333";
        return "#8fa3b1";
      case "Purple":
        return "#8c87aa";
      case "Bluish Green":
        return "#6db9a4";
      case "Purple Pink":
        return "#cf29ad";
      case "Brownish Orangy Pink":
        return "#dc7979";
      case "Pink Purple":
        return "#9c4c89";
      case "Gray Violet":
        return "#5a576b";
      case "Grayish Bluish Violet":
        return "#887788";
      case "Grayish Violetish Blue":
        return "#476b8e";
      case "Violet Gray":
        return "#656371";
      case "Violetish Gray":
        return "#656371";
      case "Grayish Violet":
        return "#5a576b";

      default:
        GraphTextColor = "#1B2653";
    }

    console.log(GraphTextColor)
  };
  console.log("data", color, getColorCode(color))
  const chartDataSpring = useSpring({
    from: { width: "0%" },
    to: { width: `${value || 0}%` },
    config: { duration: 2000 },
  });




  

  return (
    <animated.div className="custom-chart-section-wrapper">
      <span className="argyle-custom-chart-label">{label || ""}</span>
      <div className="argyle-custom-chart-main">
        <div className="custom-chart-ruler">
          <div className="custom-chart-ruler-point">0%</div>
          <div className="custom-chart-ruler-point custom-chart-point-25"></div>
          <div className="custom-chart-ruler-point">50%</div>
          <div className="custom-chart-ruler-point custom-chart-point-75"></div>
          <div className="custom-chart-ruler-point">100%</div>
        </div>
        <div className="custom-chart-progress-wrapper">
          <animated.div
            className="custom-chart-progress"
            style={{ background: `${getColorCode(color)}`, width: chartDataSpring.width }}
          ></animated.div>
        </div>
      </div>
    </animated.div>
  );
};


const getColorCode = (color) => {
  let GraphTextColor;
  switch (color) {
    case "Yellow":
      return "#ffda1a";
    case "Greenish Yellow":
      GraphTextColor = "#333";
      return "#c1e51a";
    case "Orange Yellow":
      return "#ffa330";
    case "Pink":
      return "#f563c0";
    case "Orangy Pink":
      return "#dc7979";
    case "Purplish Pink":
      GraphTextColor = "#333";
      return "#cf2985";
    case "Pinkish Purple":
      return "#a07aa0";
    case "Brownish Pink":
      GraphTextColor = "#333";
      return "#de7394";
    case "Brown Pink":
      GraphTextColor = "#333";
      return "#bc5b78";
    case "Blue":
      return "#4380c5";
    case "Gray Blue":
      return "#97bbe0";
    case "Green Blue":
      GraphTextColor = "#333";
      return "#55887e";
    case "Grayish Blue":
      GraphTextColor = "#333";
      return "#8faac5";
    case "Orange":
      GraphTextColor = "#333";
      return "#ff7c31";
    case "Yellow Orange":
      GraphTextColor = "#333";
      return "#fa9922";
    case "Yellowish Orange":
      GraphTextColor = "#333";
      return "#ff8630";
    case "Brown Orange":
      return "#d67f4a";
    case "Green":
      return "#547055";
    case "Yellow Green":
      GraphTextColor = "#333";
      return "#57ee1a";
    case "Blueish Green":
      GraphTextColor = "#333";
      return "#326b72";
    case "Red":
      GraphTextColor = "#333";
      return "#ec394d";
    case "Purplish Red":
      return "#ec3968";
    case "Brownish Red":
      return "#A52A2A";
    case "Gray":
      GraphTextColor = "#333";
      return "#8f8f8f";
    case "Blue Gray":
      GraphTextColor = "#333";
      return "#8fa3b1";
    case "Purple":
      return "#8c87aa";
    case "Bluish Green":
      return "#6db9a4";
    case "Purple Pink":
      return "#cf29ad";
    case "Brownish Orangy Pink":
      return "#dc7979";
    case "Pink Purple":
      return "#9c4c89";
    case "Gray Violet":
      return "#5a576b";
    case "Grayish Bluish Violet":
      return "#887788";
    case "Grayish Violetish Blue":
      return "#476b8e";
    case "Violet Gray":
      return "#656371";
    case "Violetish Gray":
      return "#656371";
    case "Grayish Violet":
      return "#5a576b";

    default:
      GraphTextColor = "#1B2653";
  }

  console.log(GraphTextColor)
};




const GemologicalCharacteristics = ({
  // graph_texts,
  // labelName,
  // labelValue,
  // color,
  // GraphTextColor,
  report,
  // GraphTextColor,
  // barColor,
  // height,
}) => {
  const { data, range_slider , texts } = report || {};
  const gemologicalRef = useRef();
  console.log("data??!!", report);
  const [, inView] = useInView({
    triggerOnce: true,
  });
  useEffect(() => {
    if (inView) {
      // Trigger animation when in view
      gemologicalRef.current.style.opacity = 1;
      gemologicalRef.current.style.transform = "translateY(0)";
    }
  }, [inView]);
  // const { clarity, color, saturation, shape, weightct } = data || {};
  // const {
  //   clarity: clarityval,
  //   color: colorval,
  //   saturation: saturationval,
  //   shape: shapeval,
  //   carat: caratval,
  // } = range_slider || {};

  // const weightCtTxt = weightct?.split("ct") || "";

  // const series = [
  //   {
  //     type: "column",
  //     //data: [74, 32, 2, 18, 25],
  //     data: [colorval, caratval, saturationval, shapeval, clarityval],
  //   },
  // ];
  // const options = {
  //   chart: {
  //     id: "basic-bar",
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: false,
  //       borderRadius: 0,
  //       columnWidth: "76%",
  //       barHeight: "80%",
  //       colors: {
  //         backgroundBarColors: ["#e5e7f0"],
  //         backgroundBarOpacity: 1,
  //         backgroundBarRadius: 4,
  //       },
  //       dataLabels: {
  //         position: "top",
  //       },
  //     },
  //   },
  //   fill: {
  //     colors: [barColor],
  //   },
  //   dataLabels: {
  //     formatter: function (labelValue) {
  //       return labelValue + "%";
  //     },
  //     style: {
  //       colors: [GraphTextColor],
  //       fontSize: "14px",
  //       fontWeight: "bold",
  //     },
  //     offsetX: 0,
  //     offsetY: -25,
  //   },
  //   stroke: {
  //     width: [0, 0, 0],
  //   },
  //   xaxis: {
  //     //categories: ["Yellow", "2.12 ct", "Fancy", "Pear", "VVS"],
  //     categories: [
  //       color,
  //       weightct,
  //       saturation,
  //       shape,
  //       clarity,
  //       "saturationsaturation",
  //     ],
  //     labels: {
  //       show: false,
  //       hideOverlappingLabels: false,
  //       // rotate: 0,
  //       // trim: true,
  //       // maxHeight: 60,
  //     },
  //   },
  //   grid: {
  //     show: false,
  //   },
  //   markers: {
  //     size: 6,
  //     strokeWidth: 3,
  //     fillOpacity: 0,
  //     strokeOpacity: 0,
  //     hover: {
  //       size: 8,
  //     },
  //   },
  //   yaxis: {
  //     tickAmount: 4,
  //     min: 0,
  //     max: 100,
  //     labels: {
  //       formatter: (value) => {
  //         return value;
  //       },
  //     },
  //   },
  //   tooltip: {
  //     enabled: true,
  //     enabledOnSeries: true,
  //     shared: true,
  //     followCursor: false,
  //     intersect: false,
  //     inverseOrder: false,
  //     // custom: function ({ labelValue }) {
  //     //   return (
  //     //     '<div class="arrow_box">' +
  //     //     "<span>" +
  //     //     `Approximately ${labelValue}% of ${colorval} diamonds are graded as ${saturationval}` +
  //     //     "</span>" +
  //     //     "</div>"
  //     //   );
  //     // },
  //     custom: function ({ series, seriesIndex, dataPointIndex, w }) {
  //       return (
  //         '<div class="arrow_box">' +
  //         "<span>" +
  //         "<b>" +
  //         `${w.config.xaxis.categories[dataPointIndex]} : </b> ${series[seriesIndex][dataPointIndex]}%` +
  //         "</span>" +
  //         "</div>"
  //       );
  //     },
  //     fillSeriesColor: false,
  //     theme: false,
  //     style: {
  //       fontSize: "12px",
  //       fontFamily: undefined,
  //       colors: ["#1B2653"],
  //     },
  //     onDatasetHover: {
  //       highlightDataSeries: false,
  //     },

  //     marker: {
  //       show: true,
  //     },
  //     items: {
  //       display: "block",
  //     },
  //     fixed: {
  //       enabled: false,
  //       position: "topRight",
  //       offsetX: 0,
  //       offsetY: 50,
  //     },
  //   },
  // };

  const today = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return (
    <div className="rarity-tool-card rarity-gemological-card argyle-gemological-card argyle_card_geo">
      <div className="rarity-card-content">
       <div className="rarity-report-logo">
          <svg
            width="136"
            height="45"
            viewBox="0 0 190 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.64343 56.659H0V55.983H3.96479V56.659H2.32135V61.4218H1.64343V56.659Z"
              fill="black"
            />
            <path
              d="M9.76704 55.983V61.4218H9.08227V58.9976H6.32952V61.4218H5.64475V55.983H6.32952V58.3217H9.08227V55.983H9.76704Z"
              fill="black"
            />
            <path
              d="M15.6145 60.7458V61.4218H12.1359V55.983H15.5187V56.659H12.8207V58.3295H15.2242V58.9899H12.8207V60.7458H15.6145Z"
              fill="black"
            />
            <path
              d="M21.1154 56.659V58.5548H23.5189V59.223H21.1154V61.4218H20.4306V55.983H23.8134V56.659H21.1154Z"
              fill="black"
            />
            <path
              d="M28.5448 60.0621H25.9975L25.4702 61.4218H24.7649L26.9356 55.983H27.6135L29.7911 61.4218H29.0721L28.5448 60.0621ZM28.3051 59.4405L27.2711 56.7755L26.2371 59.4405H28.3051Z"
              fill="black"
            />
            <path
              d="M35.5626 55.983V61.4218H35.0011L32.125 57.366V61.4218H31.4403V55.983H32.0018L34.8778 60.0388V55.983H35.5626Z"
              fill="black"
            />
            <path
              d="M40.0748 61.4839C39.5954 61.4839 39.1618 61.3648 38.7737 61.1265C38.3903 60.8831 38.089 60.5516 37.8698 60.132C37.6507 59.7073 37.5412 59.2307 37.5412 58.7024C37.5412 58.1741 37.6507 57.7001 37.8698 57.2806C38.089 56.8558 38.3925 56.5243 38.7806 56.2861C39.1686 56.0426 39.6023 55.9209 40.0816 55.9209C40.456 55.9209 40.7984 55.9934 41.1088 56.1384C41.4192 56.2783 41.684 56.4881 41.9031 56.7678L41.458 57.2573C41.0974 56.8273 40.6477 56.6124 40.109 56.6124C39.7529 56.6124 39.4311 56.703 39.1435 56.8843C38.8559 57.0656 38.6299 57.3168 38.4656 57.638C38.3058 57.9539 38.2259 58.3087 38.2259 58.7024C38.2259 59.0961 38.3058 59.4535 38.4656 59.7746C38.6299 60.0906 38.8559 60.3392 39.1435 60.5205C39.4311 60.7018 39.7529 60.7924 40.109 60.7924C40.6431 60.7924 41.0928 60.5749 41.458 60.1398L41.9031 60.6293C41.684 60.909 41.4169 61.1213 41.1019 61.2664C40.7915 61.4114 40.4491 61.4839 40.0748 61.4839Z"
              fill="black"
            />
            <path
              d="M45.569 59.5415V61.4218H44.8911V59.526L42.9875 55.983H43.7202L45.2541 58.85L46.7948 55.983H47.4727L45.569 59.5415Z"
              fill="black"
            />
            <path
              d="M54.0181 61.4839C53.5387 61.4839 53.105 61.3648 52.717 61.1265C52.3335 60.8831 52.0322 60.5516 51.8131 60.132C51.594 59.7073 51.4844 59.2307 51.4844 58.7024C51.4844 58.1741 51.594 57.7001 51.8131 57.2806C52.0322 56.8558 52.3358 56.5243 52.7239 56.2861C53.1119 56.0426 53.5456 55.9209 54.0249 55.9209C54.3993 55.9209 54.7416 55.9934 55.0521 56.1384C55.3625 56.2783 55.6273 56.4881 55.8464 56.7678L55.4013 57.2573C55.0406 56.8273 54.591 56.6124 54.0523 56.6124C53.6962 56.6124 53.3744 56.703 53.0868 56.8843C52.7992 57.0656 52.5732 57.3168 52.4089 57.638C52.2491 57.9539 52.1692 58.3087 52.1692 58.7024C52.1692 59.0961 52.2491 59.4535 52.4089 59.7746C52.5732 60.0906 52.7992 60.3392 53.0868 60.5205C53.3744 60.7018 53.6962 60.7924 54.0523 60.7924C54.5864 60.7924 55.0361 60.5749 55.4013 60.1398L55.8464 60.6293C55.6273 60.909 55.3602 61.1213 55.0452 61.2664C54.7348 61.4114 54.3924 61.4839 54.0181 61.4839Z"
              fill="black"
            />
            <path
              d="M59.8209 61.4839C59.3371 61.4839 58.9011 61.3648 58.5131 61.1265C58.125 60.8831 57.8192 60.549 57.5955 60.1242C57.3763 59.6995 57.2668 59.2255 57.2668 58.7024C57.2668 58.1792 57.3763 57.7053 57.5955 57.2806C57.8192 56.8558 58.125 56.5243 58.5131 56.2861C58.9011 56.0426 59.3371 55.9209 59.8209 55.9209C60.3003 55.9209 60.734 56.0426 61.122 56.2861C61.51 56.5243 61.8136 56.8558 62.0327 57.2806C62.2519 57.7001 62.3614 58.1741 62.3614 58.7024C62.3614 59.2307 62.2519 59.7073 62.0327 60.132C61.8136 60.5516 61.51 60.8831 61.122 61.1265C60.734 61.3648 60.3003 61.4839 59.8209 61.4839ZM59.8209 60.7924C60.1725 60.7924 60.4875 60.7018 60.7659 60.5205C61.049 60.3392 61.2704 60.0906 61.4301 59.7746C61.5945 59.4535 61.6767 59.0961 61.6767 58.7024C61.6767 58.3087 61.5945 57.9539 61.4301 57.638C61.2704 57.3168 61.049 57.0656 60.7659 56.8843C60.4875 56.703 60.1725 56.6124 59.8209 56.6124C59.4694 56.6124 59.1499 56.703 58.8623 56.8843C58.5792 57.0656 58.3556 57.3168 58.1912 57.638C58.0314 57.9539 57.9515 58.3087 57.9515 58.7024C57.9515 59.0961 58.0314 59.4535 58.1912 59.7746C58.3556 60.0906 58.5792 60.3392 58.8623 60.5205C59.1499 60.7018 59.4694 60.7924 59.8209 60.7924Z"
              fill="black"
            />
            <path
              d="M64.3422 55.983H65.027V60.7458H67.6222V61.4218H64.3422V55.983Z"
              fill="black"
            />
            <path
              d="M71.4191 61.4839C70.9352 61.4839 70.4992 61.3648 70.1112 61.1265C69.7232 60.8831 69.4173 60.549 69.1936 60.1242C68.9745 59.6995 68.8649 59.2255 68.8649 58.7024C68.8649 58.1792 68.9745 57.7053 69.1936 57.2806C69.4173 56.8558 69.7232 56.5243 70.1112 56.2861C70.4992 56.0426 70.9352 55.9209 71.4191 55.9209C71.8984 55.9209 72.3321 56.0426 72.7201 56.2861C73.1082 56.5243 73.4118 56.8558 73.6309 57.2806C73.85 57.7001 73.9596 58.1741 73.9596 58.7024C73.9596 59.2307 73.85 59.7073 73.6309 60.132C73.4118 60.5516 73.1082 60.8831 72.7201 61.1265C72.3321 61.3648 71.8984 61.4839 71.4191 61.4839ZM71.4191 60.7924C71.7706 60.7924 72.0856 60.7018 72.3641 60.5205C72.6471 60.3392 72.8685 60.0906 73.0283 59.7746C73.1926 59.4535 73.2748 59.0961 73.2748 58.7024C73.2748 58.3087 73.1926 57.9539 73.0283 57.638C72.8685 57.3168 72.6471 57.0656 72.3641 56.8843C72.0856 56.703 71.7706 56.6124 71.4191 56.6124C71.0676 56.6124 70.748 56.703 70.4604 56.8843C70.1774 57.0656 69.9537 57.3168 69.7893 57.638C69.6296 57.9539 69.5497 58.3087 69.5497 58.7024C69.5497 59.0961 69.6296 59.4535 69.7893 59.7746C69.9537 60.0906 70.1774 60.3392 70.4604 60.5205C70.748 60.7018 71.0676 60.7924 71.4191 60.7924Z"
              fill="black"
            />
            <path
              d="M79.145 61.4218L78.111 59.7513C77.9832 59.7617 77.8828 59.7668 77.8097 59.7668H76.6251V61.4218H75.9403V55.983H77.8097C78.4306 55.983 78.9191 56.1514 79.2751 56.4881C79.6312 56.8247 79.8093 57.2883 79.8093 57.8788C79.8093 58.2984 79.718 58.6558 79.5354 58.951C79.3528 59.2463 79.0925 59.4612 78.7547 59.5959L79.8914 61.4218H79.145ZM77.7892 59.1064C78.2229 59.1064 78.5539 59.0002 78.7821 58.7879C79.0104 58.5755 79.1245 58.2725 79.1245 57.8788C79.1245 57.4852 79.0104 57.1847 78.7821 56.9775C78.5539 56.7652 78.2229 56.659 77.7892 56.659H76.6251V59.1064H77.7892Z"
              fill="black"
            />
            <path
              d="M87.8276 61.4218L86.7936 59.7513C86.6658 59.7617 86.5653 59.7668 86.4923 59.7668H85.3076V61.4218H84.6229V55.983H86.4923C87.1131 55.983 87.6016 56.1514 87.9577 56.4881C88.3138 56.8247 88.4918 57.2883 88.4918 57.8788C88.4918 58.2984 88.4005 58.6558 88.2179 58.951C88.0353 59.2463 87.7751 59.4612 87.4373 59.5959L88.574 61.4218H87.8276ZM86.4717 59.1064C86.9054 59.1064 87.2364 59.0002 87.4647 58.7879C87.6929 58.5755 87.807 58.2725 87.807 57.8788C87.807 57.4852 87.6929 57.1847 87.4647 56.9775C87.2364 56.7652 86.9054 56.659 86.4717 56.659H85.3076V59.1064H86.4717Z"
              fill="black"
            />
            <path
              d="M94.0109 60.7458V61.4218H90.5323V55.983H93.915V56.659H91.217V58.3295H93.6206V58.9899H91.217V60.7458H94.0109Z"
              fill="black"
            />
            <path
              d="M97.4507 61.4839C97.0901 61.4839 96.7409 61.4218 96.4031 61.2974C96.0698 61.1679 95.8073 61.0022 95.6156 60.8002L95.8689 60.1942C96.0515 60.3806 96.2844 60.5334 96.5674 60.6526C96.855 60.7665 97.1494 60.8235 97.4507 60.8235C97.8479 60.8235 98.1446 60.7484 98.3409 60.5982C98.5372 60.4428 98.6354 60.2382 98.6354 59.9844C98.6354 59.7979 98.5806 59.6477 98.471 59.5337C98.366 59.4146 98.2337 59.324 98.0739 59.2618C97.9187 59.1996 97.6973 59.1297 97.4097 59.052C97.049 58.9536 96.7569 58.8552 96.5332 58.7568C96.314 58.6584 96.1246 58.5082 95.9648 58.3061C95.8096 58.099 95.732 57.8218 95.732 57.4748C95.732 57.1847 95.7982 56.9232 95.9306 56.6901C96.0675 56.457 96.2729 56.2705 96.5469 56.1307C96.8208 55.9908 97.1609 55.9209 97.5672 55.9209C97.8502 55.9209 98.1287 55.9623 98.4026 56.0452C98.6765 56.1281 98.9116 56.2472 99.1079 56.4026L98.8819 57.0242C98.681 56.8791 98.4665 56.7704 98.2382 56.6978C98.01 56.6201 97.7863 56.5813 97.5672 56.5813C97.1791 56.5813 96.887 56.6616 96.6907 56.8222C96.4989 56.9827 96.4031 57.1899 96.4031 57.4437C96.4031 57.6302 96.4578 57.783 96.5674 57.9021C96.677 58.0161 96.8116 58.1067 96.9714 58.1741C97.1357 58.2362 97.3572 58.3036 97.6356 58.3761C97.9963 58.4745 98.2862 58.5729 98.5053 58.6713C98.7244 58.7697 98.9116 58.9199 99.0668 59.122C99.2266 59.324 99.3065 59.5959 99.3065 59.9378C99.3065 60.2226 99.238 60.4842 99.101 60.7225C98.9641 60.9556 98.7564 61.142 98.4779 61.2819C98.1994 61.4166 97.857 61.4839 97.4507 61.4839Z"
              fill="black"
            />
            <path
              d="M104.72 60.7458V61.4218H101.241V55.983H104.624V56.659H101.926V58.3295H104.329V58.9899H101.926V60.7458H104.72Z"
              fill="black"
            />
            <path
              d="M109.817 60.0621H107.269L106.742 61.4218H106.037L108.207 55.983H108.885L111.063 61.4218H110.344L109.817 60.0621ZM109.577 59.4405L108.543 56.7755L107.509 59.4405H109.577Z"
              fill="black"
            />
            <path
              d="M115.917 61.4218L114.883 59.7513C114.755 59.7617 114.655 59.7668 114.582 59.7668H113.397V61.4218H112.712V55.983H114.582C115.202 55.983 115.691 56.1514 116.047 56.4881C116.403 56.8247 116.581 57.2883 116.581 57.8788C116.581 58.2984 116.49 58.6558 116.307 58.951C116.125 59.2463 115.864 59.4612 115.526 59.5959L116.663 61.4218H115.917ZM114.561 59.1064C114.995 59.1064 115.326 59.0002 115.554 58.7879C115.782 58.5755 115.896 58.2725 115.896 57.8788C115.896 57.4852 115.782 57.1847 115.554 56.9775C115.326 56.7652 114.995 56.659 114.561 56.659H113.397V59.1064H114.561Z"
              fill="black"
            />
            <path
              d="M120.765 61.4839C120.285 61.4839 119.852 61.3648 119.464 61.1265C119.08 60.8831 118.779 60.5516 118.56 60.132C118.341 59.7073 118.231 59.2307 118.231 58.7024C118.231 58.1741 118.341 57.7001 118.56 57.2806C118.779 56.8558 119.083 56.5243 119.471 56.2861C119.859 56.0426 120.292 55.9209 120.772 55.9209C121.146 55.9209 121.488 55.9934 121.799 56.1384C122.109 56.2783 122.374 56.4881 122.593 56.7678L122.148 57.2573C121.787 56.8273 121.338 56.6124 120.799 56.6124C120.443 56.6124 120.121 56.703 119.834 56.8843C119.546 57.0656 119.32 57.3168 119.156 57.638C118.996 57.9539 118.916 58.3087 118.916 58.7024C118.916 59.0961 118.996 59.4535 119.156 59.7746C119.32 60.0906 119.546 60.3392 119.834 60.5205C120.121 60.7018 120.443 60.7924 120.799 60.7924C121.333 60.7924 121.783 60.5749 122.148 60.1398L122.593 60.6293C122.374 60.909 122.107 61.1213 121.792 61.2664C121.482 61.4114 121.139 61.4839 120.765 61.4839Z"
              fill="black"
            />
            <path
              d="M128.626 55.983V61.4218H127.942V58.9976H125.189V61.4218H124.504V55.983H125.189V58.3217H127.942V55.983H128.626Z"
              fill="black"
            />
            <path
              d="M134.453 56.659V58.5548H136.857V59.223H134.453V61.4218H133.768V55.983H137.151V56.659H134.453Z"
              fill="black"
            />
            <path
              d="M141.16 61.4839C140.676 61.4839 140.24 61.3648 139.852 61.1265C139.464 60.8831 139.158 60.549 138.934 60.1242C138.715 59.6995 138.605 59.2255 138.605 58.7024C138.605 58.1792 138.715 57.7053 138.934 57.2806C139.158 56.8558 139.464 56.5243 139.852 56.2861C140.24 56.0426 140.676 55.9209 141.16 55.9209C141.639 55.9209 142.073 56.0426 142.461 56.2861C142.849 56.5243 143.152 56.8558 143.371 57.2806C143.591 57.7001 143.7 58.1741 143.7 58.7024C143.7 59.2307 143.591 59.7073 143.371 60.132C143.152 60.5516 142.849 60.8831 142.461 61.1265C142.073 61.3648 141.639 61.4839 141.16 61.4839ZM141.16 60.7924C141.511 60.7924 141.826 60.7018 142.105 60.5205C142.388 60.3392 142.609 60.0906 142.769 59.7746C142.933 59.4535 143.015 59.0961 143.015 58.7024C143.015 58.3087 142.933 57.9539 142.769 57.638C142.609 57.3168 142.388 57.0656 142.105 56.8843C141.826 56.703 141.511 56.6124 141.16 56.6124C140.808 56.6124 140.489 56.703 140.201 56.8843C139.918 57.0656 139.694 57.3168 139.53 57.638C139.37 57.9539 139.29 58.3087 139.29 58.7024C139.29 59.0961 139.37 59.4535 139.53 59.7746C139.694 60.0906 139.918 60.3392 140.201 60.5205C140.489 60.7018 140.808 60.7924 141.16 60.7924Z"
              fill="black"
            />
            <path
              d="M147.667 61.4839C147.028 61.4839 146.53 61.2767 146.174 60.8623C145.818 60.448 145.64 59.8523 145.64 59.0753V55.983H146.325V59.0443C146.325 60.2097 146.774 60.7924 147.674 60.7924C148.112 60.7924 148.447 60.65 148.68 60.3651C148.913 60.075 149.029 59.6347 149.029 59.0443V55.983H149.694V59.0753C149.694 59.8575 149.516 60.4557 149.16 60.8701C148.803 61.2793 148.306 61.4839 147.667 61.4839Z"
              fill="black"
            />
            <path
              d="M156.154 55.983V61.4218H155.592L152.716 57.366V61.4218H152.032V55.983H152.593L155.469 60.0388V55.983H156.154Z"
              fill="black"
            />
            <path
              d="M158.523 55.983H160.543C161.05 55.983 161.499 56.097 161.892 56.3249C162.284 56.5528 162.588 56.874 162.803 57.2883C163.022 57.6975 163.131 58.1689 163.131 58.7024C163.131 59.2359 163.022 59.7099 162.803 60.1242C162.588 60.5334 162.284 60.852 161.892 61.0799C161.499 61.3078 161.05 61.4218 160.543 61.4218H158.523V55.983ZM160.502 60.7458C160.89 60.7458 161.23 60.6603 161.522 60.4894C161.819 60.3185 162.047 60.0802 162.207 59.7746C162.367 59.4638 162.447 59.1064 162.447 58.7024C162.447 58.2984 162.367 57.9436 162.207 57.638C162.047 57.3272 161.819 57.0863 161.522 56.9154C161.23 56.7445 160.89 56.659 160.502 56.659H159.208V60.7458H160.502Z"
              fill="black"
            />
            <path
              d="M168.102 60.0621H165.554L165.027 61.4218H164.322L166.492 55.983H167.17L169.348 61.4218H168.629L168.102 60.0621ZM167.862 59.4405L166.828 56.7755L165.794 59.4405H167.862Z"
              fill="black"
            />
            <path
              d="M171.708 56.659H170.065V55.983H174.029V56.659H172.386V61.4218H171.708V56.659Z"
              fill="black"
            />
            <path
              d="M175.709 55.983H176.394V61.4218H175.709V55.983Z"
              fill="black"
            />
            <path
              d="M180.927 61.4839C180.443 61.4839 180.007 61.3648 179.619 61.1265C179.231 60.8831 178.925 60.549 178.702 60.1242C178.483 59.6995 178.373 59.2255 178.373 58.7024C178.373 58.1792 178.483 57.7053 178.702 57.2806C178.925 56.8558 179.231 56.5243 179.619 56.2861C180.007 56.0426 180.443 55.9209 180.927 55.9209C181.407 55.9209 181.84 56.0426 182.228 56.2861C182.616 56.5243 182.92 56.8558 183.139 57.2806C183.358 57.7001 183.468 58.1741 183.468 58.7024C183.468 59.2307 183.358 59.7073 183.139 60.132C182.92 60.5516 182.616 60.8831 182.228 61.1265C181.84 61.3648 181.407 61.4839 180.927 61.4839ZM180.927 60.7924C181.279 60.7924 181.594 60.7018 181.872 60.5205C182.155 60.3392 182.377 60.0906 182.536 59.7746C182.701 59.4535 182.783 59.0961 182.783 58.7024C182.783 58.3087 182.701 57.9539 182.536 57.638C182.377 57.3168 182.155 57.0656 181.872 56.8843C181.594 56.703 181.279 56.6124 180.927 56.6124C180.576 56.6124 180.256 56.703 179.969 56.8843C179.686 57.0656 179.462 57.3168 179.298 57.638C179.138 57.9539 179.058 58.3087 179.058 58.7024C179.058 59.0961 179.138 59.4535 179.298 59.7746C179.462 60.0906 179.686 60.3392 179.969 60.5205C180.256 60.7018 180.576 60.7924 180.927 60.7924Z"
              fill="black"
            />
            <path
              d="M189.571 55.983V61.4218H189.009L186.133 57.366V61.4218H185.449V55.983H186.01L188.886 60.0388V55.983H189.571Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M43.5682 13.3967H1.55601V47.6289H43.5682V13.3967ZM0 11.8407V49.1849H45.1242V11.8407H0Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M91.8104 13.3967H49.7982V47.6289H91.8104V13.3967ZM48.2422 11.8407V49.1849H93.3664V11.8407H48.2422Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M139.919 13.3967H97.9066V47.6289H139.919V13.3967ZM96.3506 11.8407V49.1849H141.475V11.8407H96.3506Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M188.27 13.3967H146.258V47.6289H188.27V13.3967ZM144.702 11.8407V49.1849H189.826V11.8407H144.702Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M113.468 38.0859C113.673 37.7752 113.776 37.3321 113.776 36.7579L113.8 29.4227L113.776 25.487C113.776 24.9127 113.657 24.4742 113.421 24.1714C113.184 23.8685 112.919 23.698 112.627 23.6588C112.335 23.6195 112.07 23.5691 111.833 23.5074C111.596 23.4457 111.478 23.3369 111.478 23.181C111.478 22.9331 111.706 22.8086 112.165 22.8086H116.099L118.468 22.7391C119.89 22.7391 121.107 23.0924 122.118 23.7979C123.128 24.5045 123.634 25.4556 123.634 26.6512C123.634 27.443 123.48 28.1373 123.173 28.7351C122.865 29.3329 122.524 29.7636 122.154 30.0272C121.781 30.2919 121.442 30.5207 121.134 30.7147C120.826 30.9088 120.672 31.0366 120.672 31.0994C120.672 31.2856 121.335 32.2906 122.663 34.1143C123.99 35.9391 124.898 37.1067 125.388 37.6193C125.988 38.3494 126.715 38.7139 127.568 38.7139C127.789 38.7139 127.9 38.807 127.9 38.9932C127.9 39.2265 127.805 39.3813 127.616 39.4598C127.426 39.5372 126.948 39.5753 126.181 39.5753C125.415 39.5753 124.725 39.397 124.109 39.0403C123.255 38.5592 121.841 36.6962 119.866 33.4514C119.108 32.2401 118.523 31.6344 118.113 31.6344H116.17C115.98 31.6344 115.865 31.713 115.826 31.8677C115.786 32.0225 115.767 32.4812 115.767 33.2417V35.1282L115.791 36.362V36.5717C115.791 37.2088 115.94 37.7011 116.24 38.05C116.54 38.3999 116.876 38.6018 117.248 38.6556C117.619 38.7106 117.955 38.7723 118.255 38.8418C118.555 38.9125 118.706 39.0246 118.706 39.1794C118.706 39.4284 118.563 39.5529 118.279 39.5529L114.89 39.3891L112.283 39.4822C111.951 39.4822 111.786 39.3589 111.786 39.1099C111.786 38.8463 112.118 38.6758 112.781 38.5973C113.033 38.567 113.263 38.3965 113.468 38.0859ZM17.5411 23.4839C17.8253 23.4839 18.0775 23.531 18.299 23.6241C19.042 23.9651 19.4129 24.6481 19.4129 25.6733V27.0237L19.3421 31.076C19.3421 34.3668 19.2862 36.4081 19.1766 37.1999C19.0819 37.8987 18.8285 38.3181 18.4177 38.4583C17.8812 38.6445 17.5765 38.7612 17.5057 38.8071C17.435 38.8543 17.3984 38.9788 17.3984 39.1795C17.3984 39.3511 17.5571 39.4364 17.8732 39.4364L20.7403 39.2962L23.0389 39.4823C23.2284 39.4823 23.3984 39.4431 23.5479 39.3657C23.6986 39.2883 23.7739 39.1795 23.7739 39.0404C23.7739 38.7612 23.5251 38.621 23.0275 38.621C22.5299 38.621 22.127 38.4505 21.8188 38.1084C21.5107 37.7674 21.3246 37.441 21.2618 37.1304C21.1979 36.8197 21.1671 36.5101 21.1671 36.1994L21.1911 35.2674L21.2379 31.9138C21.2379 31.6189 21.562 31.4719 22.2091 31.4719H24.2715C24.445 31.4719 24.8159 31.5033 25.3855 31.565C25.9538 31.6267 26.3214 31.6929 26.4868 31.7624C26.6523 31.8331 26.8144 31.9766 26.9731 32.1931C27.0518 32.3333 27.0918 32.5744 27.0918 32.9154C27.1545 33.3035 27.32 33.4975 27.5894 33.4975C27.6989 33.4975 27.7823 33.4628 27.8382 33.3932C27.893 33.3226 27.9204 33.1644 27.9204 32.9154L27.7549 31.0053C27.7549 30.6958 27.7902 30.3234 27.861 29.8882C27.9329 29.4531 27.9683 29.1704 27.9683 29.0381C27.9683 28.9068 27.9523 28.8171 27.9204 28.77C27.8884 28.724 27.8017 28.7005 27.6601 28.7005C27.5175 28.7005 27.4227 28.7397 27.3759 28.8171C27.328 28.8945 27.2881 29.019 27.2572 29.1895C27.2253 29.36 27.1705 29.508 27.0918 29.6314C27.0119 29.7559 26.8738 29.8849 26.6763 30.0161C26.4789 30.1484 26.2266 30.2415 25.9185 30.2954C25.6103 30.3503 24.9826 30.3772 24.0341 30.3772H23.2991L22.2811 30.4008L21.6887 30.3772C21.4034 30.3615 21.2618 29.9735 21.2618 29.213C21.2618 27.4589 21.2858 26.1623 21.3326 25.3233V25.1372C21.3486 24.61 21.4399 24.2601 21.6054 24.0896C21.7709 23.9191 22.1464 23.8327 22.7307 23.8327C23.3151 23.8327 24.8 23.9258 27.1865 24.1131C27.9124 24.1591 28.2765 24.6952 28.2765 25.7193C28.2765 26.0299 28.3826 26.1858 28.596 26.1858C28.8095 26.1858 28.9316 26.0266 28.9635 25.708C28.9943 25.3895 29.0583 24.9667 29.153 24.4384C29.2477 23.9113 29.2945 23.5456 29.2945 23.3437C29.2945 22.9714 29.161 22.7852 28.8916 22.7852L23.5125 22.9018C22.1544 22.9018 21.0518 22.8783 20.2073 22.8323C19.3615 22.7852 18.7498 22.7616 18.3709 22.7616H17.7306C17.5731 22.7616 17.4304 22.8009 17.3037 22.8783C17.177 22.9568 17.1143 23.0499 17.1143 23.1575C17.1143 23.3751 17.2569 23.4839 17.5411 23.4839ZM63.6009 36.2223C64.0746 36.9368 64.6635 37.5581 65.3665 38.0853C66.0696 38.6136 66.9735 39.0398 68.0795 39.3662C69.1854 39.6925 70.4534 39.8552 71.8835 39.8552C73.3125 39.8552 74.6592 39.5905 75.9238 39.0633C76.3975 38.8614 77.0606 38.5586 77.9143 38.1548C78.1357 38.0472 78.2613 37.907 78.2932 37.7365C78.3092 37.658 78.356 37.4449 78.4359 37.096C78.5146 36.7461 78.5808 36.4287 78.6368 36.1404C78.6916 35.8533 78.7201 35.6133 78.7201 35.4193C78.7201 35.2252 78.6493 35.1276 78.5067 35.1276C78.332 35.1276 78.2145 35.1826 78.1517 35.2903C76.6029 37.6198 74.6912 38.784 72.4165 38.784C71.0264 38.784 69.8097 38.5508 68.7666 38.0853C67.7245 37.6198 66.9028 36.9828 66.3024 36.1752C65.1326 34.5926 64.5494 32.6826 64.5494 30.4472C64.5494 28.4441 65.1805 26.8222 66.4451 25.5795C67.7085 24.3379 69.3281 23.7165 71.3026 23.7165C74.1936 23.7165 76.4055 25.1298 77.9383 27.9551C78.0638 28.1726 78.1985 28.2814 78.3412 28.2814C78.5306 28.2814 78.6254 28.1412 78.6254 27.862C78.6254 27.8003 78.6014 27.6062 78.5535 27.2799C78.5067 26.9535 78.4553 26.5385 78.4005 26.0338C78.3446 25.5302 78.3126 25.1342 78.3046 24.846C78.2967 24.5589 78.2533 24.385 78.1745 24.3222C78.0958 24.2605 78.0205 24.2291 77.9497 24.2291C77.8789 24.2291 77.7876 24.2684 77.6769 24.3458C77.5662 24.4231 77.4875 24.4624 77.4407 24.4624L76.563 24.0194C75.9786 23.7401 75.1968 23.4608 74.2175 23.1815C73.2371 22.9023 72.2659 22.7621 71.3026 22.7621C69.4068 22.7621 67.7679 23.1771 66.3857 24.0082C65.0025 24.8381 63.9798 25.9295 63.3167 27.2799C62.6525 28.6303 62.3215 30.1444 62.3215 31.8212C62.3215 33.498 62.7483 34.965 63.6009 36.2223ZM115.767 26.2553C115.767 25.1527 115.829 24.4506 115.956 24.1478C116.083 23.845 116.438 23.6936 117.023 23.6936C118.571 23.6936 119.728 24.0895 120.494 24.8813C121.261 25.6732 121.643 26.5458 121.643 27.5014C121.643 28.4558 121.356 29.2365 120.778 29.841C120.202 30.4467 119.242 30.7495 117.9 30.7495H116.975C116.532 30.7495 116.194 30.68 115.956 30.5398C115.861 30.4781 115.805 30.2571 115.791 29.8769C115.775 29.4967 115.767 28.5063 115.767 26.9069V26.2553ZM163.276 23.6241C163.054 23.531 162.802 23.4839 162.518 23.4839C162.234 23.4839 162.091 23.3751 162.091 23.1575C162.091 23.0499 162.154 22.9568 162.28 22.8783C162.407 22.8009 162.55 22.7616 162.707 22.7616H163.347C163.726 22.7616 164.338 22.7852 165.184 22.8323C166.028 22.8783 167.131 22.9018 168.489 22.9018L173.868 22.7852C174.138 22.7852 174.271 22.9714 174.271 23.3437C174.271 23.5456 174.224 23.9113 174.13 24.4384C174.035 24.9667 173.971 25.3895 173.94 25.708C173.908 26.0266 173.786 26.1858 173.573 26.1858C173.359 26.1858 173.253 26.0299 173.253 25.7193C173.253 24.6952 172.889 24.1591 172.163 24.1131C169.777 23.9258 168.292 23.8327 167.707 23.8327C167.123 23.8327 166.747 23.9191 166.582 24.0896C166.416 24.2601 166.325 24.61 166.309 25.1372V25.3233C166.262 26.1623 166.238 27.4589 166.238 29.213C166.238 29.9735 166.38 30.3615 166.665 30.3772L167.258 30.4008L168.276 30.3772H169.011C169.959 30.3772 170.587 30.3503 170.895 30.2954C171.203 30.2415 171.455 30.1484 171.653 30.0161C171.85 29.8849 171.988 29.7559 172.067 29.6314C172.147 29.508 172.202 29.36 172.234 29.1895C172.265 29.019 172.305 28.8945 172.353 28.8171C172.399 28.7397 172.494 28.7005 172.637 28.7005C172.778 28.7005 172.865 28.724 172.897 28.77C172.929 28.8171 172.945 28.9068 172.945 29.0381C172.945 29.1704 172.91 29.4531 172.838 29.8882C172.767 30.3234 172.731 30.6958 172.731 31.0053L172.897 32.9154C172.897 33.1644 172.87 33.3226 172.815 33.3932C172.759 33.4628 172.676 33.4975 172.566 33.4975C172.297 33.4975 172.131 33.3035 172.067 32.9154C172.067 32.5744 172.028 32.3333 171.95 32.1931C171.791 31.9766 171.629 31.8331 171.463 31.7624C171.298 31.6929 170.93 31.6267 170.362 31.565C169.793 31.5033 169.422 31.4719 169.248 31.4719H167.186C166.539 31.4719 166.214 31.6189 166.214 31.9138L166.167 35.2674L166.144 36.1994C166.144 36.5101 166.175 36.8197 166.238 37.1304C166.301 37.441 166.487 37.7674 166.795 38.1084C167.104 38.4505 167.506 38.621 168.004 38.621C168.502 38.621 168.751 38.7612 168.751 39.0404C168.751 39.1795 168.675 39.2883 168.525 39.3657C168.375 39.4431 168.205 39.4823 168.016 39.4823L165.717 39.2962L162.85 39.4364C162.534 39.4364 162.375 39.3511 162.375 39.1795C162.375 38.9788 162.412 38.8543 162.482 38.8071C162.553 38.7612 162.857 38.6445 163.394 38.4583C163.805 38.3181 164.059 37.8987 164.153 37.1999C164.263 36.4081 164.319 34.3668 164.319 31.076L164.39 27.0237V25.6733C164.39 24.6481 164.019 23.9651 163.276 23.6241Z"
              fill="black"
            />
            <path
              d="M0 47.86H189.999V49.6609H0V47.86Z"
              fill="url(#paint0_linear_734_551)"
            />
            <path
              d="M178.028 0.858696H175.659V0H181.374V0.858696H179.005V6.90905H178.028V0.858696Z"
              fill="black"
            />
            <path
              d="M189.052 6.90905L189.042 1.87531L186.545 6.07009H186.091L183.594 1.90492V6.90905H182.646V0H183.456L186.338 4.85607L189.18 0H189.99L190 6.90905H189.052Z"
              fill="black"
            />
            <defs>
              <linearGradient
                id="paint0_linear_734_551"
                x1="6.91549e-10"
                y1="49.6546"
                x2="190.031"
                y2="49.6546"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF0081" />
                <stop stop-color="#CF6983" />
                <stop offset="0.487807" stop-color="#FFCD00" />
                <stop offset="1" stop-color="#0053FF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <h6 class="date d-none date_block date-text">{months[today.getMonth()]} <span class="lowercase text-dark date-text"> {today.getDate()}th, </span> {today.getFullYear()}</h6>
        <h3>the argyle rarity report</h3>
        <DiamondCharacteristics
          report={report?.data}
          text={texts?.text}
          texts={texts}
          // diamondShape={diamondShape}
        />
        <div className="rarity-chart-info">
          <h6>Gemological Characteristics</h6>
          <p>Market Distribution Percentage</p>
        </div>
      </div>
      <div className="rarity-gemological-wrapper">
        <ChartData
          label={`~ ${range_slider?.color}% of Fancy color diamonds are ${range_slider?.debug_data[0][1]}`}
          color={data?.color}
          value={range_slider?.color}
        
        />
         <ChartData
          label={`~ ${range_slider?.saturation}% of ${range_slider?.debug_data[0][1]} diamonds are graded as ${range_slider?.debug_data[1][1]}`}
          color={data?.color}
          value={range_slider?.saturation}
         
        />
         <ChartData
          label={`~ ${range_slider?.debug_data[3][2]} of ${range_slider?.debug_data[0][1]} diamonds are cut as ${range_slider?.debug_data[3][1]}`}
          color={data?.color}
          value={range_slider?.debug_data[3][2]}
         
        />
         <ChartData
          label={`~ ${range_slider?.debug_data[2][2]} of ${range_slider?.debug_data[0][1]} diamonds are in
            the ${range_slider?.debug_data[2][1]} carat weight category`}
          color={data?.color}
          value={range_slider?.debug_data[2][2]}
        
        />
         <ChartData
          label={`~ ${range_slider?.debug_data[4][2]} of ${range_slider?.debug_data[0][1]} diamonds in this grade, weight and shape are ${range_slider?.debug_data[4][1]==="IF" ? "FL or IF" :range_slider?.debug_data[4][1]}`}
          color={data?.color}
          value={range_slider?.debug_data[4][2]}
       
        />

        {/* {range_slider?.debug_data?.map((value, i) => (
          <ChartData
            label={value}
            color={data?.color}
            value={value[2]}
            index={i}
          
          />
        ))} */}
        {/* <CustomChat  range_slider={range_slider} data={data}/> */}
        {/* <Chart options={options} type="bar" series={series} width="100%" /> */}
        {/* <div
          className="chart-xaxis-wrapper" */}
        {/* // style={{
          //   bottom: `${color === "Red" ? "-14px" : "-2px"}`,
          // }}
        // > */}
        {/* <span>{color}</span>
          <span>
            {weightCtTxt[0]} {weightCtTxt[1]}
            <br />
            Carat
          </span>
          <span>{saturation}</span>
          <span>{shape}</span>
          <span>{clarity}</span>
        </div> */}
      </div>
      <div className="rarity-gemological-footer">
        <p className="m-0">
          Any data acquired from the FCRF Rarity Calculator is not a guarantee
          or valuation. The Argyle rarity figures were collected by the FCRF
          from open sources and do not represent any official information
          provided by Rio Tinto. For additional information regarding data
          disclaimers or limitations, please visit www.fcresearch.org or contact
          us at: customers@fcresearch.org
          <br />
          <span>Report generated on  {formatDateReport(report?.timestamp)}</span>
        </p>
      </div>
      <div className="rarity-tool-right-mobile-view">
        <DiamondRare report={report}  colorCode={getColorCode(data?.color)} />
      </div>
    </div>
  );
};

export default GemologicalCharacteristics;
